import Vue from 'vue'
import AsyncComputed from 'vue-async-computed'
import App from './App.vue'
import mask from './plugins/mask'
import vuetify from './plugins/vuetify'
import i18n from './locales'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import '@/components/LusFlexBox'
import '@/styles/main.scss'

Vue.use(AsyncComputed)
Vue.use(VueClipboard)

Vue.config.productionTip = false

new Vue({
  mask,
  vuetify,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app')
